// extracted by mini-css-extract-plugin
module.exports = {"NavigationContainer":"NavigationCareer_NavigationContainer__A8xbx","NavigationRoot":"NavigationCareer_NavigationRoot__7GC9o"};